import CashbackTransactionDetailsScreen from 'features/rewards/Cashback/CashbackTransactionDetails/CashbackTransactionDetailsScreen';
import React from 'react';

export default function Page() {
  return <CashbackTransactionDetailsScreen />;
}
